/**
 * Checkout collapses
 */
import {PAYYO_CARD_INIT_ERROR} from "../../utils/internalEvents";


/**
 * @todo: Make deprecated, unused in new design.
 */
export class CheckoutCollapses
{
    constructor()
    {
        this.collapses = {
            personalInformation: $('#checkout__collapse_itm__personal-info'),
            payment: $('#checkout__collapse_itm__payment'),
            summary: $('#checkout__collapse_itm__summary'),
        };

        this.inputs = [
            '#mobile-payer_name',
            '#mobile-payer_email',
            '#mobile-payer_phonenumber',
        ];
    }

    init()
    {
        const self = this;

        /**
         * Listen for collapses
         */
        $(document).on('click', '.checkout__collapse_itm_header', function(e){
            e.preventDefault();
            const $this = $(this);
            const $item = $this.closest('.checkout__collapse_itm');

            self.toggleCollapse($item);
        });

        /**
         * Listen for first step inputs to be complete, then open second step.
         */

        $(document).on('change', self.inputs.join(', '), function (e){
            let completedCount = 0;

            $.each(self.inputs, function(i, selector){
                if($(selector).val() !== '') {
                    completedCount++;
                }

                if(completedCount === self.inputs.length) {
                    self.openCollapse(self.getPaymentCollapse());
                    self.scrollToCollapse(self.getPaymentCollapse());
                }
            });
        });


        /**
         * On payyo error - scroll to Payment dropdown.
         */
        $(document).on(PAYYO_CARD_INIT_ERROR, function(e){
           self.scrollToCollapse(self.collapses.payment);
        });
    }

    /**
     * Toogle collapse open/close state
     * @param $collapse
     */
    toggleCollapse($collapse)
    {
        $collapse.toggleClass('collapsed');
    }

    closeCollapse($collapse)
    {
        $collapse.addClass('collapsed');
    }

    openCollapse($collapse)
    {
        $collapse.removeClass('collapsed');
    }

    /**
     * @return {jQuery|HTMLElement}
     */
    getPaymentCollapse()
    {
        return this.collapses.payment;
    }

    /**
     * @return {jQuery|HTMLElement}
     */
    getPersonalInfoCollapse()
    {
        return this.collapses.personalInformation;
    }

    /**
     * @param $collapse
     */
    scrollToCollapse($collapse)
    {
        console.log('lets scroll');
        console.log($collapse.offset().top);

        $('#mobile-checkout-block').animate(
            {
                scrollTop: $collapse.offset().top,
            },
            500,
        );
    }
}
